import axios from "axios";
import { put, takeLatest } from "redux-saga/effects";

import { sagaActions } from "./Action";
import {
  //login--------------
  getUserSuccessAction,
  getUserErrorAction,
  //plantlist----------
  // setplantListRetrieveActions,
  SetPlantListRetrieveSuccessResponse,
  SetPlantListRetrieveError,
  // Client List
  // setClientListRetrieveActions,
  SetClientListRetrieveSuccessResponse,
  SetClientListRetrieveError,
  // File List
  SetplantRetrieveSuccessResponse,
  SetFileListRetrieveSuccessResponse,
  SetFileListRetrieveprojectSuccessResponse,
  SetFileListRetrieveprojectwbsSuccessResponse,
  SetFileListRetrieveError,
  CreatePlantSuccessResponse,
  CreatePlantRetrieveError,
  CreateProjectSuccessResponse,
  CreateProjectRetrieveError,
  FetchProjectWbsSuccessResponse,
  FetchProjectWbsError,
  CreateProjectWbsSuccessResponse,
  CreateProjectWbsError,
  UpdateProjectWbsSuccessResponse,
  UpdateProjectWbsError,
  UpdateProjectSuccessResponse,
  UpdateProjectError,
  UpdatePlantSuccessResponse,
  UpdatePlantError,
  CreateScheduleSuccessResponse,
  CreateScheduleError,
  RetrieveInvoiceSuccessResponse,
  RetrieveInvoiceError,
  RetrieveScheduledInvoiceSuccessResponse,
  RetrieveScheduledInvoiceError,
  SetPlantListgetdropSuccessResponse,
  SetPlantListgetdropError,
  SetprojectListgetdropSuccessResponse,
  SetprojectListgetdropError,
  SetprojectwbsListgetdropSuccessResponse,
  SetprojectwbsListgetdropError,
  SetUserGetSuccessResponse,
  SetUserGetError,
  SetUserPostSuccessResponse,
  SetUserPostError,
  SetUserPutSuccessResponse,
  SetUserPutError,
  SetCommonPostSuccessResponse,
  SetCommonPostError,
  setFileRetriveList,
  SetGraphListRetrieveSuccessResponse,
  SetGraphListRetrieveError,
  getForgotUserSuccessAction,
  getForgotUserErrorAction,
  getVerifyOtpUserSuccessAction,
  getVerifyOtpUserErrorAction,
  getResetPasswordUserSuccessAction,
  getResetPasswordUserErrorAction,
} from "./Slice";
//------API----Calls--------------------
import {
  loginapi,
  plantlist,
  plantProjects,
  plantCreate,
  fileList,
  projectCreate,
  projectWbsFetch,
  projectWbsCreate,
  scheduleCreate,
  scheduledget,
  invoiceget,
  new_invoice,
  plant_drop,
  project_drop,
  projectwbs_drop,
  usergetdata,
  commoncreation,
  invoiceAmount,
  forgotOTPSentApi,
  verifyOTPSentApi,
  resetPasswordApi,
} from "../Context/apidata";
import { store } from "../Redux/Store";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getLoaderAction } from "./Loader";
import { useNavigate } from "react-router-dom";
// params: {
//         search: payloads.payload.search,
//         page_size: payloads.payload.page_size,
//         page: payloads.payload.page,
//         mode: payloads.payload.mode,
//       },

// <-----------------Login---------------------->

function* getUserSaga(payload) {
  //console.log(payload, "payloasd");
  //console.log(payload, "payloasd");
  try {
    const response = yield axios({
      method: "post",
      url: loginapi,
      data: {
        email: payload.payload.email,
        password: payload.payload.Password,
      },
    });
    //console.log(response, "response");
    toast.info(` ${response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });

    yield put(getUserSuccessAction(response.data));

    localStorage.setItem("login", "false");
    //  window.location.href = "/role";
  } catch (error) {
    //console.log(error, "error");
    yield put(getUserErrorAction(error));
    toast.info(` ${error.response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });
  }
}
// <-----------------Forgot Password Email---------------------->

function* getForgotUserSaga(payload) {
  //console.log(payload, "payloasd");
  //console.log(payload, "payloasd");
  try {
    yield put(getLoaderAction(true));

    const response = yield axios({
      method: "post",
      url: forgotOTPSentApi,
      data: {
        email: payload.payload.email,
      },
    });
    console.log(response, "response");
    toast.info(` ${response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });

    yield put(getForgotUserSuccessAction(response.data));
    yield put(getLoaderAction(false));

    localStorage.setItem("login", "false");
    payload?.payload.navigate("/verifyotp");
  } catch (error) {
    yield put(getLoaderAction(false));

    //console.log(error, "error");
    yield put(getForgotUserErrorAction(error));
    toast.info(` ${error.response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });
  }
}
// <-----------------Verfy Otp Email---------------------->

function* getVerifyOtpUserSaga(payload) {
  //console.log(payload, "payloasd");
  console.log(payload, "payloasd");
  try {
    yield put(getLoaderAction(true));

    const response = yield axios({
      method: "post",
      url: verifyOTPSentApi,
      data: {
        otp: payload.payload.otp,
        user: payload.payload.user,
      },
    });
    console.log(response, "response");
    toast.info(` ${response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });

    yield put(getVerifyOtpUserSuccessAction(response.data));
    yield put(getLoaderAction(false));

    localStorage.setItem("login", "false");
    payload?.payload.navigate("/resetpassword");
  } catch (error) {
    //console.log(error, "error");
    yield put(getVerifyOtpUserErrorAction(error));
    toast.info(` ${error.response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });
    yield put(getLoaderAction(false));
  }
}
// <-----------------Reset Password---------------------->

function* getresetPasswordUserSaga(payload) {
  //console.log(payload, "payloasd");
  console.log(payload, "payloasd");
  try {
    yield put(getLoaderAction(true));

    const response = yield axios({
      method: "put",
      url: resetPasswordApi,
      data: {
        otp: payload.payload.otp,
        password: payload.payload.password,
      },
      params: {
        id: payload.payload.id,
      },
    });
    console.log(response, "response");
    toast.info(` ${response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });
    yield put(getLoaderAction(false));

    yield put(getResetPasswordUserSuccessAction(response.data));

    localStorage.setItem("login", "false");
    payload?.payload.navigate("/");
  } catch (error) {
    //console.log(error, "error");
    yield put(getLoaderAction(false));

    yield put(getResetPasswordUserErrorAction(error));
    toast.info(` ${error.response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });
  }
}
// <-----------------PlantList fetch---------------------->

function* getPlantListSaga(payload) {
  //console.log(payload);
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: plantlist,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetPlantListRetrieveSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(SetPlantListRetrieveError(error));
    }
  }
}
// <-----------------Client List fetch---------------------->

function* getClientListSaga(payload) {
  if (payload !== undefined) {
    try {
      // yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: plantProjects,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
        params: payload.payload,
      });

      yield put(SetClientListRetrieveSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(SetClientListRetrieveError(error));
    }
  }
}

// <-----------------File List fetch---------------------->

function* getFileListSaga(payload) {
  //console.log(payload, "createcreatecreatecreatecreatecreatecreate");
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: fileList,
        data:
          payload.payload.wbs || payload.payload.plant
            ? payload.payload
            : { directory_path: payload.payload },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setFileRetriveList(response.data.data));
      if (payload.payload.wbs) {
        yield put(
          SetFileListRetrieveprojectwbsSuccessResponse(
            response.data.data.files,
          ),
        );
        console.log(response.data.data, "kjaskllkjdsalksdadfhk");
      } else if (payload.payload.plant) {
        yield put(SetFileListRetrieveSuccessResponse(response.data.data.files));
        yield put(SetplantRetrieveSuccessResponse(response.data.data.emails));
      } else {
        yield put(
          SetFileListRetrieveprojectSuccessResponse(response.data.data.files),
        );
      }
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(SetFileListRetrieveError(error));
    }
  }
}

// <-----------------Create plant---------------------->

function* postPlantCreateSaga(payload) {
  //console.log(payload, "payloasd");
  yield put(getLoaderAction(true));

  try {
    const response = yield axios({
      method: "post",
      url: plantCreate,
      data: {
        plant: payload.payload.plant,
        plant_common: payload.payload.plant_common,
        emails: payload.payload.emails,
      },
    });
    //console.log(response, "response");
    toast.info(` ${response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });
    yield put(CreatePlantSuccessResponse(response.data));
    yield put(getLoaderAction(false));

    localStorage.setItem("login", "false");
    //  window.location.href = "/role";
  } catch (error) {
    //console.log(error, "error");
    yield put(CreatePlantRetrieveError(error));
    toast.info(` ${error.response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });
  }
}

// <-----------------Create Project---------------------->
function* postProjectCreateSaga(payload) {
  //console.log(payload, "createPayloadcreatePayloadcreatePayload");
  yield put(getLoaderAction(true));
  try {
    const response = yield axios({
      method: "post",
      url: projectCreate,
      data: payload.payload,
    });
    //console.log(response, "response");
    toast.info(` ${response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });
    yield put(CreateProjectSuccessResponse(response.data));
    localStorage.setItem("login", "false");
    yield put(getLoaderAction(false));
    //  window.location.href = "/role";
  } catch (error) {
    //console.log(error, "error");
    yield put(getLoaderAction(false));
    yield put(CreateProjectRetrieveError(error));
    toast.info(` ${error.response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });
  }
}

// <-----------------Project WBS List fetch---------------------->
function* getProjectWbsSaga(payload) {
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: projectWbsFetch,
        params: payload.payload,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(FetchProjectWbsSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(FetchProjectWbsError(error));
    }
  }
}

// <-----------------Create Project Wbs ---------------------->

function* postProjectWbsCreateSaga(payload) {
  //console.log(payload, "payloasd");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: projectWbsCreate,
      data: payload.payload,
    });
    //console.log(response, "response");
    toast.info(` ${response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });
    yield put(getLoaderAction(false));
    yield put(CreateProjectWbsSuccessResponse(response.data));

    localStorage.setItem("login", "false");
    //  window.location.href = "/role";
  } catch (error) {
    //console.log(error, "error");
    yield put(CreateProjectWbsError(error));
    toast.info(` ${error.response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });
  }
}
// <-----------------Update Plant ---------------------->

function* updatePlantSaga(payload) {
  //console.log(payload.payload.projectName, "submitsubmitsubmitsubmitsubmit");
  yield put(getLoaderAction(true));
  try {
    const response = yield axios({
      method: "put",
      url: plantlist,
      data: payload.payload.projectName,
      params: {
        id: payload.payload.id,
      },
    });
    //console.log(response, "response");
    toast.info(` ${response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });
    yield put(UpdatePlantSuccessResponse(response.data));
    yield put(getLoaderAction(false));

    localStorage.setItem("login", "false");
    //  window.location.href = "/role";
  } catch (error) {
    //console.log(error, "error");
    yield put(UpdatePlantError(error));
    toast.info(` ${error.response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });
  }
}
// <-----------------Update Project ---------------------->

function* updateProjectSaga(payload) {
  //console.log(payload.payload, "submitsubmitsubmitsubmitsubmit");

  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: plantProjects,
      data: payload.payload.projectName,
      params: {
        id: payload.payload.id,
      },
    });
    //console.log(response, "response");
    toast.info(` ${response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });
    yield put(UpdateProjectSuccessResponse(response.data));
    yield put(getLoaderAction(false));
    localStorage.setItem("login", "false");
    //  window.location.href = "/role";
  } catch (error) {
    //console.log(error, "error");
    yield put(UpdateProjectError(error));
    toast.info(` ${error.response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });
  }
}
// <-----------------Update Project Wbs ---------------------->

function* updateProjectWbsSaga(payload) {
  //console.log(payload, "payloasd");
  yield put(getLoaderAction(true));

  try {
    const response = yield axios({
      method: "put",
      url: projectWbsFetch,
      data: payload.payload.data,
      params: payload.payload.id,
    });
    //console.log(response, "response");
    toast.info(` ${response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });
    yield put(UpdateProjectWbsSuccessResponse(response.data));
    yield put(getLoaderAction(false));

    localStorage.setItem("login", "false");
    //  window.location.href = "/role";
  } catch (error) {
    //console.log(error, "error");
    yield put(UpdateProjectWbsError(error));
    toast.info(` ${error.response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });
  }
}
// <-----------------Create plant---------------------->

function* postScheduleCreateSaga(payload) {
  //console.log(payload, "payloasd");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: scheduleCreate,
      data: payload.payload,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    //console.log(response, "response");
    toast.info(` ${response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });
    yield put(CreateScheduleSuccessResponse(response.data));
    yield put(getLoaderAction(false));

    localStorage.setItem("login", "false");
    //  window.location.href = "/role";
  } catch (error) {
    //console.log(error, "error");
    yield put(CreateScheduleError(error));
    yield put(getLoaderAction(false));

    toast.info(` ${error.response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });
  }
}

function* SchedulegetSaga(payload) {
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: scheduledget,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(RetrieveScheduledInvoiceSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(RetrieveScheduledInvoiceError(error));
    }
  }
}

function* invoicegetSaga(payload) {
  yield put(getLoaderAction(true));
  if (payload !== undefined) {
    try {
      yield put(RetrieveInvoiceSuccessResponse([]));
      const response = yield axios({
        method: "get",
        url: invoiceget,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(RetrieveInvoiceSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(RetrieveInvoiceError(error));
    }
  }
}
function* getProjectListSaga(payload) {
  yield put(getLoaderAction(true));
  if (payload !== undefined) {
    try {
      const response = yield axios({
        method: "get",
        url: invoiceAmount,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      console.log(response.data.data, "response.data.data");

      yield put(SetGraphListRetrieveSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(SetGraphListRetrieveError(error));
    }
  }
}

function* new_invoiceSaga(payload) {
  yield put(getLoaderAction(true));
  if (payload !== undefined) {
    try {
      const response = yield axios({
        method: "get",
        url: new_invoice,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(RetrieveInvoiceSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(RetrieveInvoiceError(error));
    }
  }
}

function* plantdrop(payload) {
  //console.log(payload);
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: plant_drop,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetPlantListgetdropSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(SetPlantListgetdropError(error));
    }
  }
}

function* projectdrop(payload) {
  //console.log(payload);
  yield put(getLoaderAction(true));
  if (payload !== undefined) {
    try {
      const response = yield axios({
        method: "get",
        url: project_drop,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetprojectListgetdropSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(SetprojectListgetdropError(error));
    }
  }
}

function* projectwbsdrop(payload) {
  //console.log(payload);
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: projectwbs_drop,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetprojectwbsListgetdropSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(SetprojectwbsListgetdropError(error));
    }
  }
}

function* userget(payload) {
  //console.log(payload);
  if (payload.payload.id == undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: usergetdata,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetUserGetSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(SetUserGetError(error));
    }
  } else {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: usergetdata,
        params: {
          id: payload.payload.id,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetUserGetSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(SetUserGetError(error));
    }
  }
}

function* userpost(payload) {
  if (payload.payload.id == undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: usergetdata,
        data: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      toast.info(` ${response?.data?.status?.message} `, {
        position: toast.POSITION.TOP_RIGHT,
        className: "toast-message",
      });

      yield put(SetUserPostSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(SetUserPostError(error));
    }
  }
}

function* userput(payload) {
  //console.log(payload.payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: usergetdata + "?id=" + payload.payload.id,
      data: payload.payload.data,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    toast.info(` ${response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });

    yield put(SetUserPutSuccessResponse(response.data.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(SetUserPutError(error));
  }
}

function* CommonPost(payload) {
  //console.log(payload.payload, "payload23");

  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: commoncreation,
      data: payload.payload,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    toast.info(` ${response?.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
    });

    yield put(SetCommonPostSuccessResponse(response.data.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(SetCommonPostError(error));
  }
}

//-------Generator--Funtion
function* watchGetUser() {
  yield takeLatest(
    sagaActions.FETCH_FORGOT_DATA_SAGA + "/getForgotUserAction",
    getForgotUserSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_VERIFY_OTP_DATA_SAGA + "/getVerifyOtpUserAction",
    getVerifyOtpUserSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_RESET_PASSWORD_DATA_SAGA + "/getResetPasswordUserAction",
    getresetPasswordUserSaga,
  );
  yield takeLatest(sagaActions.FETCH_DATA_SAGA + "/getUserAction", getUserSaga);
  yield takeLatest(
    sagaActions.FETCH_DATA_PLANTS + "/setplantListRetrieveActions",
    getPlantListSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_DATA_CLIENT + "/setClientListRetrieveActions",
    getClientListSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_FILE_LIST + "/setFileListRetrieveActions",
    getFileListSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_DATA_CREATE_PLANT + "/CreatePlantActions",
    postPlantCreateSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_DATA_CREATE_PROJECT + "/CreateProjectActions",
    postProjectCreateSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_DATA_PROJECT_WBS + "/FetchProjectWbsActions",
    getProjectWbsSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_DATA_CREATE_PROJECT_WBS + "/CreateProjectWbsActions",
    postProjectWbsCreateSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_DATA_UPDATE_PLANT + "/UpdatePlantActions",
    updatePlantSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_DATA_UPDATE_PROJECT + "/UpdateProjectActions",
    updateProjectSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_DATA_UPDATE_PROJECT_WBS + "/UpdateProjectWbsActions",
    updateProjectWbsSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_DATA_CREATE_SCHEDULE + "/CreateScheduleActions",
    postScheduleCreateSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_DATA_RETRIEVE_INVOICE + "/RetrieveInvoiceActions",
    invoicegetSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_DATA_PROJECT + "/setGraphListRetrieveActions",
    getProjectListSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_DATA_RETRIEVE_NEWINVOICE + "/RetrieveNewInvoiceActions",
    new_invoiceSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_DATA_RETRIEVE_SCHEDULED_INVOICE +
      "/RetrieveScheduledInvoiceActions",
    SchedulegetSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_PLANT_DROP + "/setplantListgetdropActions",
    plantdrop,
  );
  yield takeLatest(
    sagaActions.FETCH_PROJECT_DROP + "/setprojectListgetdropActions",
    projectdrop,
  );
  yield takeLatest(
    sagaActions.FETCH_PROJECTWBS_DROP + "/setprojectwbsListgetdropActions",
    projectwbsdrop,
  );

  yield takeLatest(sagaActions.FETCH_USERDATA + "/setUserGetActions", userget);

  yield takeLatest(
    sagaActions.FETCH_USERDATA_POST + "/setUserPostActions",
    userpost,
  );

  yield takeLatest(
    sagaActions.FETCH_USERDATA_PUT + "/setUserPutActions",
    userput,
  );

  yield takeLatest(
    sagaActions.FETCH_COMMON_POST + "/setCommonPostActions",
    CommonPost,
  );
}
export default watchGetUser;
